export const KeyCodes = {
  Backspace: 8,
  Tab: 9,
  Enter: 13,
  LeftArrow: 37,
  UpArrow: 38,
  RightArrow: 39,
  DownArrow: 40,
  Delete: 46
};

export enum ResultSlots {
  header = 'header',
  body = '',
  footer = 'footer',
  fallbackImage = 'fallback-image',
  slideshowPreviousIcon = 'slideshow-previous-icon',
  slideshowNextIcon = 'slideshow-next-icon'
}
